import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-app-message',
  templateUrl: './app-message.component.html',
  styleUrls: ['./app-message.component.scss']
})
export class AppMessageComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
